import type { ReactElement } from 'react'
import type { BadgeComponentType } from '../../components/badge'
import type { ElementWithOptionalImageType } from '../../types'

export enum AvatarSize {
  xsmall = 'xs',
  small = 's',
  medium = 'm',
  large = 'l',
}

export enum AvatarShape {
  circle = 'circle',
  square = 'square',
}

export enum AvatarStyle {
  neutral = 'neutral',
  red = 'red',
  redSoft = 'redSoft',
  yellow = 'yellow',
  yellowSoft = 'yellowSoft',
  green = 'green',
  greenSoft = 'greenSoft',
  blue = 'blue',
  blueSoft = 'blueSoft',
  purple = 'purple',
  purpleSoft = 'purpleSoft',
}

export interface AvatarPropsBase {
  badge?: BadgeComponentType
  className?: string
  label?: string
  loading?: boolean
  size?: AvatarSizeType
  style?: AvatarStyleType
  shape?: AvatarShapeType
}

type AvatarSizeType = `${AvatarSize}`
type AvatarStyleType = `${AvatarStyle}`
type AvatarShapeType = `${AvatarShape}`

export type AvatarProps = ElementWithOptionalImageType<AvatarPropsBase>
export type AvatarComponentType = ReactElement<AvatarProps>
